import script from "./StatusDot.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusDot.vue?vue&type=script&setup=true&lang=js"

import "./StatusDot.vue?vue&type=style&index=0&id=8ec9c418&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ec9c418"]])

export default __exports__